import { RootState } from "shared/config/store"

export const selectModalType = (state: RootState) => state.modal.type
export const selectModalContext = (state: RootState) => state.modal.context
export const selectModalData = (state: RootState) => state.modal.data
export const selectIsModalOpen = (state: RootState) => state.modal.type !== null
